
import { defineComponent } from "vue";
import store from "@/store/index";
import ResponseData from "@/_models/ResponseData";
import OnboardingChecklistService from "@/services/OnboardingChecklistService";
import qrcode from "qrcode-generator";
import { NetworkType, PublicAccount } from "tsjs-xpx-chain-sdk";
import XarcadeAccountService from "../../../services/XarcadeAccountService";
import { createToast } from "mosha-vue-toastify";
import { Helper } from "@/utils/Helper";
import { Peer } from "peerjs";

export default defineComponent({

  name: 'homeConnectMainnetWalletComponent',
  props: {
    networkLabel: String,
  },

  components: {
    
  },

  data: function () {
    return {
      currentWalletAddress: "",
      currentPublicKey: "",
      XPXsent: false,
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
      qr: "",
      isDisplayConnectMainnet: false,
      password: '',
      showPassword: false,
      mainnetJwtToken: store.getters["auth/mainnetJwtToken"] ?? "",
      isDisplayPasswordError: false,
    };
  },

    methods: {
    async generateQr() {
      // register user to mainnet db
      this.importAccountMainnet();
      // login to get mainnet jwt
      let login = {
        username: this.userData.username,
        password: this.password,
      };
      let validLogin = false;
      await XarcadeAccountService.loginUser(login, 'mainnet').then(async(response: ResponseData) => {
        if (response.data["success"]) {
          this.mainnetJwtToken = response.data["authenticationData"]["jwtToken"];
          validLogin = true;
          // return false if the login is invalid, and display invalid password instead of QR connect modal
        }else{
          this.isDisplayPasswordError = true;
          return;
        }
      }).catch((error) => {
        this.isDisplayPasswordError = true;
        return;
      });
      console.log(validLogin);
      if(!validLogin){
        return;
      }

      const peer = new Peer();
      const secret = "this is a secret";

      peer.on("open", (id) => {
        const temp = {
          type: "connect",
          recvId: peer.id,
          secret: secret,
          generationHash: this.$store.getters['config/getMainnetGenerationHash'],
        };
        const qr = qrcode(0, "H");
        qr.addData(JSON.stringify(temp));
        qr.make();
        this.qr = qr.createSvgTag();
      });

      peer.on("connection", (conn) => {
        // console.log("connected to " + conn.peer);

        conn.on("data", (data: any) => {
          // received the public key and signature

          // validate the signature
          const signerPubAcc = PublicAccount.createFromPublicKey(data.publicKey, this.$store.getters['config/getMainnetNetworkType']);
          const isValid = signerPubAcc.verifySignature(secret, data.signature);
          if (isValid) {
            // console.log("Account verified!");
            // console.log(`Received public key: ${data.publicKey}`);
            conn.send("success");
            this.currentPublicKey = data.publicKey;
            this.currentWalletAddress = signerPubAcc.address.pretty();
            // this.importAccountMainnet();
            this.saveWalletAddress();
          } else {
            console.error("signature doesn't match!");
          }
        });
      });
      this.isDisplayConnectMainnet = true;
    },

    importAccountMainnet(){
      XarcadeAccountService.registerMainnetUser(this.userData.userId, this.jwtToken);
    },

    saveWalletAddress() {
      if (this.userData !== "" && this.jwtToken !== "") {

        XarcadeAccountService.updateUserWalletAddress(this.userData.userId, this.mainnetJwtToken, this.currentPublicKey, 'mainnet')
          .then((response: ResponseData) => {
            if (response.status === 200) {
              // console.log(this.currentWalletAddress)
              // console.log(this.currentPublicKey)
              this.userData.mainnetWalletAddress = this.currentWalletAddress;
              this.userData.mainnetPublicAddress = this.currentPublicKey;

              this.$store.dispatch('auth/mainnetLogin',{
                userData: this.userData,
                jwtToken: this.mainnetJwtToken,
              });
              this.updateOnboardingChecklist(this.userData.userId, this.jwtToken);
              createToast(
                {
                  title: "Yay!",
                  description: response.data["message"] ? response.data["message"] : response.data,
                },
                {
                  position: "bottom-right",
                  type: "success",
                }
              );
              this.isDisplayConnectMainnet = false;
            }
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
      }
    },

    updateOnboardingChecklist(userId: string, token: string) {
      OnboardingChecklistService.getOnboardingChecklist(userId, token)
        .then((response: ResponseData) => {
          OnboardingChecklistService.saveUpdatedOnboardingChecklist(response.data.items, 9, userId, token);
        })
        .catch((error) => {
          Helper.endpointErrorHandling(error);
        });
    },

    checkCurrentWalletAddress() {
      if (this.userData !== "") {
        this.currentWalletAddress = this.userData.mainnetWalletAddress;
      }
    },

    copy(id:string){
      let stringToCopy = document.getElementById(id).getAttribute("copyValue");
      Helper.copyToClipboard(stringToCopy);
      createToast(
        {
          title: "Wallet Address Copied",
          description: this.currentWalletAddress,
        },
        {
          position: "bottom-right",
          type: "info",
        }
      );
    }
  },

  computed: {
    mainneturl() {
      return store.getters['config/getMainnetApi'];
    },
    mainnetLabel() {
      return store.getters['config/configMainnetLabel'];
    },
    assetUrl() {
      return store.getters['config/assetUrl'];
    },

    disableConnect() {
      return this.password.length < 8;
    }
  },

  mounted() {
    this.checkCurrentWalletAddress();
  },


});
